import React from "react";

import { getCarSetting, updateCar } from "../../model/car";
import { getLoggedProfile } from "../../model/profile";
import { commonErr } from "../common/errors";
import { formatPrice } from "../common/common";
import { MessageBox, MessageLine } from "../common/messagebox";
import ReactSimpleRange from "react-simple-range";
import { LoadingInline, LoadingOverlay } from "../common/loading";

class CarSettingRenting extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",
		};
		this.updateCarInfo = this.updateCarInfo;
	}

	init = (car) => {
		getCarSetting({ carId: car.id }).then((settingResp) => {
			const setting = settingResp.data.data;
			var i, j;
			if (setting) {
				const mortgages = [];
				const papers = [];
				this.setState({
					err: settingResp.data.error,
					errMsg: settingResp.data.errorMessage,

					notes: setting.policiesSpecific === 1 ? setting.policies : car.notes,
					isPoliciesSpecific: setting.policiesSpecific === 1,

					isLimited: car.limitEnable === 1,
					limited: car.limitKM,
					limitedPrice: car.limitPrice,

					car: car,
					setting: setting,
				});

				if (setting.mortgages) {
					for (i = 0; i < setting.mortgages.length; ++i) {
						var mortgage = {
							id: setting.mortgages[i].id,
							name: setting.mortgages[i].name,
							groupId: setting.mortgages[i].groupId,
							edit: setting.mortgages[i].edit === 1,
							groupRequired: setting.mortgages[i].groupRequired === 1,
							checked: setting.mortgages[i].val === 1,
						};
						mortgages.push(mortgage);
					}
					for (i = 0; i < mortgages.length; ++i) {
						for (j = 0; j < car.mortgages.length; ++j) {
							if (mortgages[i].id === car.mortgages[j].id && car.mortgages[j].val === 1) {
								mortgages[i].checked = true;
							}
						}
					}
				}
				this.setState({
					err: settingResp.data.error,
					errMsg: settingResp.data.errorMessage,
					car: car,
					mortgagesSpecific: setting.mortgagesSpecific === 1,
					mortgages: mortgages,
					setting: setting,
				});

				// if (setting.mortgagesSpecific === 0) {
				// 	getLoggedProfile().then((profileResp) => {
				// 		const profile = profileResp.data.data.profile;
				// 		if (profile.mortgages) {
				// 			for (j = 0; j < profile.mortgages.length; ++j) {
				// 				var mortgage = {
				// 					id: profile.mortgages[j].id,
				// 					name: profile.mortgages[j].name,
				// 					groupId: profile.mortgages[j].groupId,
				// 					edit: profile.mortgages[j].edit === 1,
				// 					groupRequired: profile.mortgages[j].groupRequired === 1,
				// 					checked: profile.mortgages[j].val === 1,
				// 				};
				// 				mortgages.push(mortgage);
				// 			}
				// 		}
				// 		if (profile) {
				// 			this.setState({
				// 				err: profileResp.data.error,
				// 				errMsg: profileResp.data.errorMessage,

				// 				mortgagesSpecific: setting.mortgagesSpecific === 1,
				// 				mortgages: mortgages,
				// 				car: car,
				// 				setting: setting,
				// 			});
				// 		}
				// 	});
				// } else {
				// 	if (setting.mortgages) {
				// 		for (i = 0; i < setting.mortgages.length; ++i) {
				// 			var mortgage = {
				// 				id: setting.mortgages[i].id,
				// 				name: setting.mortgages[i].name,
				// 				groupId: setting.mortgages[i].groupId,
				// 				edit: setting.mortgages[i].edit === 1,
				// 				groupRequired: setting.mortgages[i].groupRequired === 1,
				// 				checked: setting.mortgages[i].val === 1,
				// 			};
				// 			mortgages.push(mortgage);
				// 		}
				// 		for (i = 0; i < mortgages.length; ++i) {
				// 			for (j = 0; j < car.mortgages.length; ++j) {
				// 				if (mortgages[i].id === car.mortgages[j].id && car.mortgages[j].val === 1) {
				// 					mortgages[i].checked = true;
				// 				}
				// 			}
				// 		}
				// 	}
				// 	this.setState({
				// 		err: settingResp.data.error,
				// 		errMsg: settingResp.data.errorMessage,
				// 		car: car,
				// 		mortgagesSpecific: setting.mortgagesSpecific === 1,
				// 		mortgages: mortgages,
				// 		setting: setting,
				// 	});
				// }

				if (setting.allRequiredPapers) {
					for (i = 0; i < setting.allRequiredPapers.length; ++i) {
						var requiredPaper = {
							id: setting.allRequiredPapers[i].id,
							name: setting.allRequiredPapers[i].name,
							logo: setting.allRequiredPapers[i].logo,
							groupId: setting.allRequiredPapers[i].groupId,
							edit: setting.allRequiredPapers[i].edit === 1,
							groupRequired: setting.allRequiredPapers[i].groupRequired === 1,
							checked: setting.allRequiredPapers[i].val === 1,
							conditionOr: setting.allRequiredPapers[i].conditionOr === 1,
							firstChecked: setting.allRequiredPapers[i].val === 1,
						};
						papers.push(requiredPaper);
					}
					for (i = 0; i < papers.length; ++i) {
						for (j = 0; j < car.requiredPapers.length; ++j) {
							if (papers[i].id === car.requiredPapers[j].id && car.requiredPapers[j].val === 1) {
								papers[i].checked = true;
								papers[i].firstChecked = true;
							}
						}
					}
					// if (car.requiredPapersSpecific === 0) {
					// 	getLoggedProfile().then((loggedProfileResp) => {
					// 		const profile = loggedProfileResp.data.data.profile;
					// 		if (profile.requiredCarPapers) {
					// 			for (j = 0; j < profile.requiredCarPapers.length; ++j) {
					// 				var requiredPaper = {
					// 					id: profile.requiredCarPapers[j].id,
					// 					name: profile.requiredCarPapers[j].name,
					// 					logo: profile.requiredCarPapers[j].logo,
					// 					groupId: profile.requiredCarPapers[j].groupId,
					// 					edit: profile.requiredCarPapers[j].edit === 1,
					// 					groupRequired: profile.requiredCarPapers[j].groupRequired === 1,
					// 					checked: profile.requiredCarPapers[j].val === 1,
					// 				};
					// 				papers.push(requiredPaper);
					// 			}
					// 		}
					// 		if (profile) {
					// 			this.setState({
					// 				err: loggedProfileResp.data.error,
					// 				errMsg: loggedProfileResp.data.errorMessage,

					// 				requiredPapersSpecific: car.requiredPapersSpecific === 1,
					// 				requiredPapers: papers,

					// 				car,
					// 				setting,
					// 			});
					// 		}
					// 	});
					// } else {
					// 	if (setting.allRequiredPapers) {
					// 		for (i = 0; i < setting.allRequiredPapers.length; ++i) {
					// 			var requiredPaper = {
					// 				id: setting.allRequiredPapers[i].id,
					// 				name: setting.allRequiredPapers[i].name,
					// 				logo: setting.allRequiredPapers[i].logo,
					// 				groupId: setting.allRequiredPapers[i].groupId,
					// 				edit: setting.allRequiredPapers[i].edit === 1,
					// 				groupRequired: setting.allRequiredPapers[i].groupRequired === 1,
					// 				checked: setting.allRequiredPapers[i].val === 1,
					// 				conditionOr: setting.allRequiredPapers[i].conditionOr === 1,
					// 				firstChecked: setting.allRequiredPapers[i].val === 1,
					// 			};
					// 			papers.push(requiredPaper);
					// 		}
					// 		for (i = 0; i < papers.length; ++i) {
					// 			for (j = 0; j < car.requiredPapers.length; ++j) {
					// 				if (papers[i].id === car.requiredPapers[j].id && car.requiredPapers[j].val === 1) {
					// 					papers[i].checked = true;
					// 					papers[i].firstChecked = true;
					// 				}
					// 			}
					// 		}
					// 	}

					this.setState({
						err: settingResp.data.error,
						errMsg: settingResp.data.errorMessage,

						requiredPapersSpecific: car.requiredPapersSpecific === 1,
						requiredPapers: papers,

						car,
						setting,
					});
				}
			} else {
				this.setState({
					err: settingResp.data.error,
					errMsg: settingResp.data.errorMessage,
				});
			}
		});
	};

	componentDidMount() {
		const car = this.props.car;
		this.init(car);
	}

	componentWillReceiveProps(props) {
		const car = props.car;
		this.init(car);
	}

	onMortgagesChange = (event) => {
		const mortgages = this.state.mortgages.slice();
		for (var i = 0; i < mortgages.length; ++i) {
			if (!mortgages[i].edit) {
				continue;
			}
			if (mortgages[i].groupRequired && mortgages[i].groupId === event.target.name) {
				if (mortgages[i].id !== event.target.value) {
					mortgages[i].checked = false;
				}
			}
			if (mortgages[i].id === event.target.value) {
				mortgages[i].checked = event.target.checked;
			}
		}

		this.setState({
			mortgages: mortgages,
		});
	};

	onPolicyChange = (event) => {
		this.setState({
			notes: event.target.value,
		});
	};

	onRequiredPapersChange = (event) => {
		const papers = this.state.requiredPapers.slice();

		for (var i = 0; i < papers.length; ++i) {
			if (!papers[i].edit) {
				continue;
			}
			if (papers[i].groupRequired && papers[i].groupId === event.target.name) {
				if (papers[i].id !== event.target.value) {
					papers[i].checked = false;
				}
			}
			if (papers[i].id === event.target.value) {
				papers[i].checked = event.target.checked;
			}
		}

		// if(event.target.value === "hk" && event.target.checked){
		//     for (var i = 0; i < papers.length; ++i) {
		//         if (papers[i].id === "pp") {
		//             papers[i].checked = false;
		//             break;
		//         }
		//     }
		// } else if(event.target.value === "pp" && event.target.checked){
		//     for (var i = 0; i < papers.length; ++i) {
		//         if (papers[i].id === "hk") {
		//             papers[i].checked = false;
		//             break;
		//         }
		//     }
		// }

		this.setState({
			requiredPapers: papers,
		});
	};

	// onRequiredPapersOtherChange = (event) => {
	//     this.setState({
	//         requiredPapersOther: event.target.value
	//     });
	// }

	toggleLimited = () => {
		this.setState({
			isLimited: !this.state.isLimited,
		});
	};

	onLimitedChange = (range) => {
		this.setState({
			limited: range.value,
		});
	};

	onLimitedPriceRangeChange = (range) => {
		this.setState({
			limitedPrice: range.value,
		});
	};

	hideMessageBox = () => {
		this.setState({
			updateErrMsg: "",
		});
	};

	updateCarInfo = () => {
		const limitEnable = this.state.isLimited;
		const limitKM = this.state.limited;
		const limitPrice = this.state.limitedPrice;
		const notes = this.state.notes;

		var mortgages = "";
		for (var i = 0; i < this.state.mortgages.length; ++i) {
			const mortgage = this.state.mortgages[i];
			if (mortgage.checked === true) {
				if (mortgages === "") {
					mortgages = mortgage.id;
				} else {
					mortgages += ";" + mortgage.id;
				}
			}
		}

		var requiredPapers = "";
		// var requiredPapersOther = "";
		for (var i = 0; i < this.state.requiredPapers.length; ++i) {
			const paper = this.state.requiredPapers[i];
			if (paper.checked === true) {
				if (requiredPapers === "") {
					requiredPapers = paper.id;
				} else {
					requiredPapers += ";" + paper.id;
				}
			}
		}
		// requiredPapersOther = this.state.requiredPapersOther;

		this.setState({
			err: commonErr.LOADING,
		});
		updateCar(this.state.car.id, {
			mortgages: mortgages,
			requiredPapers: requiredPapers,
			// requiredPapersOther: encodeURI(requiredPapersOther),
			limitEnable: limitEnable,
			limitKM: limitKM,
			limitPrice: limitPrice,
			notes: encodeURI(notes),
		}).then((resp) => {
			this.setState({
				err: resp.data.error,
				updateErrMsg: resp.data.errorMessage,
				isPoliciesSpecific: this.state.isPoliciesSpecific,
			});
		});
	};

	render() {
		var content;

		if (this.state.err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else if (!this.state.car || !this.state.setting) {
			content = <MessageLine message="Không tìm thấy thông tin." />;
		} else {
			content = (
				<div className="content">
					<div className="content-container">
						<div className="form-default">
							<h3 className="title">Tài sản thế chấp</h3>
							<div className="space m"></div>
							<div className="list-features">
								<ul>
									{this.state.mortgages &&
										this.state.mortgages.map((mortgage) => (
											<li key={mortgage.id}>
												{mortgage.groupRequired ? (
													<div className="custom-radio">
														<input
															type="radio"
															id={`mortgage_${mortgage.id}`}
															// disabled={!this.state.mortgagesSpecific || !mortgage.edit}
															name={mortgage.groupId}
															value={mortgage.id}
															checked={mortgage.checked}
															onChange={this.onMortgagesChange}
														/>
														<label htmlFor={`mortgage_${mortgage.id}`}>{mortgage.name}</label>
													</div>
												) : (
													<div className="custom-checkbox-selected">
														<input
															type="checkbox"
															id={`mortgage_${mortgage.id}`}
															// disabled={!this.state.mortgagesSpecific || !mortgage.edit}
															name={mortgage.groupRequired ? mortgage.groupId : ""}
															checked={mortgage.checked}
															value={mortgage.id}
															onChange={this.onMortgagesChange}
														/>
														<label htmlFor={`mortgage_${mortgage.id}`}>{mortgage.name}</label>
													</div>
												)}
											</li>
										))}
								</ul>
							</div>
							<div className="line"></div>

							<h3 className="title">Giấy tờ thuê xe</h3>

							<span className="note marginBottom-s">
								Thiết lập các giấy tờ khách bắt buộc phải có (bản gốc) khi thuê xe {this.state.car.name}.
							</span>

							<div className="space m"></div>

							<div className="list-features">
								{this.state.requiredPapers &&
									this.state.requiredPapers.map((paper, i) => (
										<React.Fragment key={paper.id}>
											{!paper.edit ? (
												<div className="paper-required">
													<img loading="lazy" className="paper" src={paper.logo} alt="Mioto - Thuê xe tự lái" />
													{paper.name}
												</div>
											) : (
												<React.Fragment>
													{/* {i === 1 && <p className="options">Và chọn 1 trong 2 hình thức</p>} */}
													<ul>
														<li className="width-100">
															<div className="custom-radio">
																<input
																	type={"radio"}
																	id={`paper_${paper.id}`}
																	name={paper.groupId}
																	value={paper.id}
																	checked={paper.checked}
																	onChange={this.onRequiredPapersChange}
																/>
																<label htmlFor={`paper_${paper.id}`}>
																	<img loading="lazy" className="paper" src={paper.logo} />
																	<span>{paper.name}</span>
																</label>
															</div>
														</li>
													</ul>
												</React.Fragment>
											)}
										</React.Fragment>
									))}
							</div>

							<div className="line" />

							{/* <h3 className="title">Giới hạn số km</h3>
						<p className="position-relative pos-1">
							<div className="switch-on-off" style={{ right: "0", position: "absolute", bottom: "10px" }}>
								<input className="switch-input" id="cb-instant-limited" type="checkbox" checked={this.state.isLimited} onClick={this.toggleLimited} />
								<label className="switch-label" for="cb-instant-limited"></label>
							</div>
						</p>

						{this.state.isLimited && <div className="col-1">
							<div className="line-form end">
								<label className="label">Số km tối đa trong 1 ngày</label>
								<div className="range-slider">
									<ReactSimpleRange
										step={5}
										min={this.state.setting.limitKMMin}
										max={this.state.setting.limitKMMax}
										value={this.state.limited}
										sliderSize={14}
										thumbSize={16}
										label={false}
										trackColor={"#00a550"}
										thumbColor={"#141414"}
										onChange={this.onLimitedChange}
									/>
								</div>
								<span style={{ float: "right", fontSize: "14px" }}>{`${this.state.limited}km`}</span>
								<div className="space m" />
								<p className="pl">
									<span className="note">Số km đề xuất: {`${this.state.setting.limitKMRecommend}km`}</span>
								</p>
							</div>
						</div>} */}

							{this.state.isLimited && (
								<div className="col-2">
									<div className="line-form end">
										<label className="label">Phí vượt giới hạn (tính mỗi km)</label>
										<ReactSimpleRange
											step={1000}
											min={1000}
											max={this.state.setting.limitPriceMax}
											value={this.state.limitedPrice}
											sliderSize={14}
											thumbSize={16}
											label={false}
											trackColor={"#00a550"}
											thumbColor={"#141414"}
											onChange={this.onLimitedPriceRangeChange}
										/>
										<span style={{ float: "right", fontSize: "14px" }}>{formatPrice(this.state.limitedPrice)}</span>
										<span className="note">Phí đề xuất: {formatPrice(this.state.setting.limitPriceRecommend)}</span>
									</div>
								</div>
							)}
							<div className="clear"></div>
							<div className="line"></div>

							<h3 className="title">Điều khoản thuê xe</h3>
							<span className="note marginBottom-s">Thiết lập các yêu cầu khi thuê xe {this.state.car.name}.</span>

							{/* {!this.state.isPoliciesSpecific && <span className="note">Lưu ý: Xe đang áp dụng thiết lập điều khoản chung. Tắt thiết lập chung nếu muốn tuỳ chỉnh riêng cho xe này</span>} */}
							{/* <div className="position-relative pos-1 d-flex" style={{ justifyContent: "space-between" }}>
							<p style={{ marginBottom: 0 }}>Sử dụng thiết lập chung</p>
							<div className="switch-on-off">
								<input className="switch-input" id="cb-policies-spec" type="checkbox" checked={!this.state.isPoliciesSpecific} onClick={this.togglePoliciesSpecific} />
								<label className="switch-label" for="cb-policies-spec"></label>
							</div>
						</div> */}
							<div className="space m"></div>
							<div className="form-default">
								<div className="line-form end custom-textarea">
									<textarea
										className="textarea"
										// disabled={!this.state.isPoliciesSpecific}
										onChange={this.onPolicyChange}
										value={this.state.notes ? this.state.notes : ""}
										placeholder="Không sử dụng xe vào mục đích phi pháp. Lái xe cẩn thận, giữ xe sạch sẽ, trả xe đúng giờ. Phụ thu 500k nếu hút thuốc lá trong xe."></textarea>
								</div>
							</div>
							<div className="space m"></div>
							<div className="line"></div>
							<a className="btn btn-primary btn--m" onClick={this.updateCarInfo}>
								Lưu thay đổi
							</a>
						</div>
					</div>
					<MessageBox
						show={this.state.err <= commonErr.SUCCESS && this.state.updateErrMsg !== ""}
						error={this.state.err}
						hideModal={this.hideMessageBox}
						message={this.state.errMsg}
					/>
				</div>
			);
		}
		return content;
	}
}

export default CarSettingRenting;
